module.exports = __webpack_public_path__ + "static/media/profile-bg.baf6b40a.jpg";